import { useEffect, useState } from 'react';
import { Collapse } from '@mui/material';

import { CarouselPage, useCarousel } from 'src/hooks';
import { CarouselItem } from 'src/models/Carousel';

import {
  CarouselItem as HeroCarouselItem,
  ItemType,
} from './HeroCarousel/types';
import HeroCarousel from './HeroCarousel';

const pageTypes = {
  homepage: CarouselPage.Homepage,
  sessions: CarouselPage.Sessions,
  challenges: CarouselPage.Challenges,
  practicePlans: CarouselPage.PracticePlans,
  meditations: CarouselPage.Meditations,
  pilates: CarouselPage.Pilates,
  pranayama: CarouselPage.Pranayama,
  fitSessions: CarouselPage.FitSessions,
  discoveries: CarouselPage.Discoveries,
  teachers: CarouselPage.Teachers,
  benefits: CarouselPage.Benefits,
};

export const Carousel: React.FC<{
  page: keyof typeof pageTypes;
  previewItem?: CarouselItem;
}> = ({ page, previewItem }) => {
  const pageSpecificItems = useCarousel(pageTypes[page]);
  const items = previewItem ? [previewItem] : pageSpecificItems;

  const [visible, setVisible] = useState(false);
  useEffect(() => setVisible(items.length > 0), [items.length]);

  if (items.length === 0) {
    return null;
  }

  const carouselItems: HeroCarouselItem[] = items.map((item) => ({
    ...item,
    ctaUrl: item.ctaLink,
    imageUrl: item.image ?? '',
    focalPoint: [0.5, 0.5],
    type: ItemType.ImageLeft,
  }));

  return (
    <Collapse in={visible}>
      <HeroCarousel items={carouselItems} />
    </Collapse>
  );
};
